"use client";

import { FC } from "react";

interface IndexValueDisplayProps {
  symbol: string;
  ltp: number;
  chg: number;
  chgPer: number;
  pcr: number;
  pcrLabelPrefix?: string;
}

const formatSigned = (value: number): string => {
  const fixed = Number(value)?.toFixed(2);
  if (value > 0) return `+${fixed}`;
  if (value < 0) return fixed;
  return fixed;
};

export const IndexValueDisplay: FC<IndexValueDisplayProps> = ({
  symbol,
  ltp,
  chg,
  chgPer,
  pcr,
  pcrLabelPrefix,
}) => {
  const safeLtp = Number(ltp ?? 0);
  const isLtpPositive = Number(chgPer) >= 0;
  const labelPrefix = pcrLabelPrefix ?? "PCR";

  let performanceIcon;

  if (isLtpPositive) {
    performanceIcon = (
      <i className="icomoon inline-flex h-[12px] w-[12px] items-center justify-center overflow-hidden leading-none text-[#067161] before:inline-block before:h-[12px] before:w-[12px] before:leading-[12px] before:text-[12px] before:content-['\e980']" />
    );
  } else {
    performanceIcon = (
      <i className="icomoon inline-flex h-[12px] w-[12px] items-center justify-center overflow-hidden leading-none text-[#B40000] before:inline-block before:h-[12px] before:w-[12px] before:leading-[12px] before:text-[12px] before:content-['\e981']" />
    );
  }

  return (
    <div className="py-[8px] flex items-center justify-between">
      <div className="flex flex-col gap-2">
        <div className="md:text-[16px] font-[400px] text-[#1a1a1a]">
          {symbol}
        </div>
        <div className="text-[14px] font-[400px] text-[#666666]">
          {labelPrefix} {Number(pcr ?? 0).toFixed(2)}
        </div>
      </div>
      <div className="flex flex-col gap-2 items-end">
        <div
          className={`font-[400px] text-[16px] ${
            isLtpPositive ? "text-[#067161]" : "text-[#B40000]"
          }`}
        >
          <span className="inline-flex items-center gap-[4px]">
            {safeLtp.toFixed(2)} {performanceIcon}
          </span>
        </div>
        <div className="text-[14px] font-[400px] text-[#666666]">
          {formatSigned(chg)} ({formatSigned(chgPer)}%)
        </div>
      </div>
    </div>
  );
};